import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinvarvandpune() {



const cardData =
  {
    keyword: 'Bus On Rent in Varvand Pune',
    heading: 'Sanavi Travels: Bus On Rent in Varvand Pune',
    headingDescription: 'Sanavi Travels offers Bus On Rent in Varvand Pune with a strong focus on safety, comfort, reliability, and affordability for all types of group travel. Whether you are planning a wedding ceremony, corporate meeting, school excursion, picnic tour, religious yatra, or long-distance outstation journey, our wide range of AC buses, Non-AC buses, mini buses, luxury coaches, and large seating capacity buses ensures a smooth and stress-free travel experience. Each bus is well-maintained, regularly serviced, and driven by professional chauffeurs who understand local and outstation routes. With flexible one-way and round-trip rental packages, transparent pricing with no hidden charges, and round-the-clock booking support, bus rental in Varvand Pune becomes a convenient and dependable choice for families, corporate groups, institutions, and tourists alike.',

    top: 'Top Places to Visit Near Varvand Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Varvand Village Area",
    "description": "Varvand is a calm and developing locality near Pune, surrounded by rural landscapes and connected to nearby towns and industrial areas. It serves as a convenient starting point for group travel, family outings, local tours, and short-distance journeys. Many travelers prefer bus rentals from Varvand for organized and comfortable group movement."
  },
  {
    "title": "Daund City",
    "description": "Daund is an important railway junction and commercial hub located close to Varvand. Groups often travel between Varvand and Daund for business activities, family functions, educational visits, and social events, making bus rental a practical and economical choice."
  },
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Bhigwan Bird Sanctuary is a popular nature and picnic destination near Varvand, especially famous for migratory birds and scenic backwaters. Renting a bus is ideal for bird-watching groups, photography tours, school trips, and nature enthusiasts traveling together."
  },
  {
    "title": "Jejuri Khandoba Temple",
    "description": "Jejuri is a well-known pilgrimage destination visited by thousands of devotees throughout the year. Groups from Varvand frequently hire buses for religious tours, temple visits, and festival travel to ensure safe, comfortable, and well-coordinated journeys."
  },
  {
    "title": "Pune City Attractions",
    "description": "Varvand provides easy access to Pune city, including popular attractions such as Dagdusheth Ganpati, Shaniwar Wada, shopping markets, and cultural landmarks. Bus rentals make group sightseeing tours convenient, cost-effective, and time-efficient."
  },
  {
    "title": "MIDC and Industrial Areas",
    "description": "Nearby MIDC and industrial zones generate regular demand for employee transportation, corporate meetings, and factory visits. Corporate groups often rely on bus rentals from Varvand for punctual and organized travel."
  },
  {
    "title": "Agricultural Fields and Rural Routes",
    "description": "The surroundings of Varvand feature agricultural fields and village roads that reflect rural Maharashtra. These routes are commonly explored during school excursions, rural exposure tours, and group educational trips."
  },
  {
    "title": "Local Picnic Spots",
    "description": "Several small picnic spots, open fields, and riverside locations near Varvand attract families, schools, and social groups. Hiring a bus ensures safe travel, group coordination, and a relaxed picnic experience."
  },
  {
    "title": "Wedding Venues Near Varvand",
    "description": "Numerous wedding halls, banquet lawns, and marriage venues around Varvand depend on bus rentals for guest transportation. Buses help manage large gatherings efficiently and ensure timely arrivals."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Varvand is well connected to popular outstation destinations such as Shirdi, Nashik, Solapur, Kolhapur, and Mumbai. Bus rentals are widely used for long-distance family tours, corporate travel, and pilgrimage journeys."
  }
]
,



"services": [
{
"name": "Bus On Rent in Varvand Pune",
"description": "Bus On Rent in Varvand Pune provides spacious, comfortable, and well-maintained buses suitable for families, large groups, corporate clients, and tourists. These buses are ideal for weddings, picnics, sightseeing tours, religious trips, and long-distance travel, offering smooth rides and professional driver support."
},
{
"name": "Bus Hire in Varvand Pune",
"description": "Bus Hire in Varvand Pune offers flexible and reliable bus rental options for group travel, corporate outings, school tours, and family functions. With punctual service and clean buses, it ensures stress-free transportation for every occasion."
},
{
"name": "AC Bus on Rent Varvand",
"description": "AC Bus on Rent Varvand ensures a cool, comfortable, and refreshing travel experience with fully air-conditioned interiors, ample legroom, and comfortable seating, making it ideal for summer travel and long journeys."
},
{
"name": "Non AC Bus Hire Varvand",
"description": "Non AC Bus Hire Varvand offers budget-friendly transportation options for short-distance travel, rural routes, school trips, and local group journeys without compromising safety."
},
{
"name": "Luxury Bus Rental Varvand Pune",
"description": "Luxury Bus Rental Varvand Pune delivers premium travel experiences with stylish interiors, modern amenities, spacious seating, and enhanced comfort for weddings, VIP travel, and corporate events."
},
{
"name": "Mini Bus on Rent Varvand",
"description": "Mini Bus on Rent Varvand is suitable for small groups, family functions, local events, and short-distance travel, offering convenience and economical pricing."
},
{
"name": "32 Seater Bus on Rent Varvand",
"description": "32 Seater Bus on Rent Varvand is perfect for medium-sized groups such as school excursions, office outings, and social gatherings, providing ample seating and luggage space."
},
{
"name": "35 Seater Bus Hire Varvand",
"description": "35 Seater Bus Hire Varvand offers comfortable and spacious seating arrangements for large group travel, weddings, corporate tours, and long-distance journeys."
},
{
"name": "Bus on Rent Varvand for Wedding",
"description": "Bus on Rent Varvand for Wedding ensures organized, timely, and comfortable transportation for wedding guests, family members, and relatives attending marriage ceremonies."
},
{
"name": "Bus on Rent Varvand for Corporate",
"description": "Bus on Rent Varvand for Corporate supports employee transportation, meetings, conferences, factory visits, and corporate events with punctual and professional service."
},
{
"name": "Bus on Rent Varvand for Picnic",
"description": "Bus on Rent Varvand for Picnic offers safe, affordable, and convenient travel for school picnics, family outings, and group leisure trips."
},
{
"name": "Bus Rental Varvand for Outstation",
"description": "Bus Rental Varvand for Outstation provides dependable long-distance travel solutions to major cities and tourist destinations with experienced drivers and comfortable buses."
},
{
"name": "Bus Hire Varvand with Driver",
"description": "Bus Hire Varvand with Driver offers chauffeur-driven buses where professional drivers handle navigation, traffic, and safety, allowing passengers to relax throughout the journey."
},
{
"name": "Cheap Bus on Rent Varvand Pune",
"description": "Cheap Bus on Rent Varvand Pune provides cost-effective bus rental services for groups seeking affordable travel solutions without compromising on comfort or reliability."
},
{
"name": "Best Bus Rental Service Varvand",
"description": "Best Bus Rental Service Varvand is trusted for clean buses, courteous drivers, transparent pricing, and customer-focused group transportation services."
}
],

"tableData": [
["Bus On Rent in Varvand Pune", "Bus Hire in Varvand Pune"],
["AC Bus on Rent Varvand", "Non AC Bus Hire Varvand"],
["Luxury Bus Rental Varvand Pune", "Mini Bus on Rent Varvand"],
["32 Seater Bus on Rent Varvand", "35 Seater Bus Hire Varvand"],
["Wedding Bus Varvand", "Corporate Bus Varvand"],
["Picnic Bus Varvand", "Outstation Bus Varvand"],
["Bus Hire Varvand with Driver", "Cheap Bus on Rent Varvand Pune"],
["Best Bus Rental Service Varvand", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Varvand Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable bus rental services in Varvand Pune for family trips, corporate travel, school tours, religious journeys, and group outings."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "All buses are clean, air-conditioned where applicable, and regularly maintained to ensure a smooth and pleasant travel experience."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and experienced drivers are familiar with Varvand and surrounding routes, ensuring safe, punctual, and stress-free journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels follows clear and honest pricing policies, including fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team remains available round the clock to assist with bookings, route planning, and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "We offer hourly, half-day, full-day, and customized bus rental plans based on group size and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Every bus is thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel environment."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups, disciplined schedules, and dependable service for all bus rentals in Varvand Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Varvand Pune?',
    answer: 'Yes, Sanavi Travels provides reliable bus rental services in Varvand Pune for all types of group travel.'
  },
  {
    question: 'How can I book a bus in Varvand Pune?',
    answer: 'You can book a bus easily through our website or by calling our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Varvand Pune?',
    answer: 'We provide mini buses, 32-seater buses, 35-seater buses, luxury buses, AC buses, and Non-AC buses.'
  },
  {
    question: 'Are the drivers experienced with Varvand routes?',
    answer: 'Yes, all drivers are professional, licensed, and familiar with Varvand and nearby travel routes.'
  },
  {
    question: 'Can I select pickup and drop-off locations?',
    answer: 'Yes, you can choose flexible pickup and drop-off points as per your travel plan.'
  },
  {
    question: 'Is bus service available 24x7 in Varvand Pune?',
    answer: 'Yes, Sanavi Travels offers round-the-clock bus rental services in Varvand Pune.'
  },
  {
    question: 'Are buses sanitized before every trip?',
    answer: 'Yes, buses are cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are accepted?',
    answer: 'We accept UPI, debit cards, credit cards, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our support team remains available throughout the trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajit Pawar',
    feedback: 'We hired a bus from Varvand Pune for a family wedding. The journey was smooth and very comfortable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rutuja Shinde',
    feedback: 'Sanavi Travels arranged an AC bus for our picnic trip from Varvand. Excellent service and clean bus.',
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];






const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent in Varvand Pune - Sanavi Travels",
  "description": "Sanavi Travels provides bus on rent in Varvand Pune for weddings, corporate travel, picnics, and outstation trips. Choose from AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with experienced drivers at affordable prices.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "190"
  }
};








  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus on Rent in Varvand Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Varvand Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate events, picnics, and outstation travel with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/211.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinvarvandpune;